// NPM
import React, { useState, Fragment } from 'react';
import { Typography } from '@mui/material';

// COMPONENTS
import FindCustomerTable from '../../components/admin/findcustomer/FindCustomerTable';
import Paginator from '../../components/common/Paginator';
import AdminSearch from '../../components/admin/findcustomer/AdminSearch';

// REPORTS
import Users from '../Reports/UserReports';

// NETWORK
import useUserRequest from '../../requests/UsersRequest';

// I18N
import FindCustomerFormattedMessages from '../../messages/admin/FindCustomerFormattedMessages';
import Layout from '../../components/layouts/Layout';
import { AdminRoutes } from '../../routes/AdminRoutes';
import Loader from '../../components/common/Loader';

const AdminFindCustomer = ({
  accessLevel,
  accessType,
  updateActingProviderDetails,
  updateActingCustomerDetails,
  navigate,
  errorHandler,
  centres,
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    showResults: false,
    hideSearchForm: false,
    loading: false,
    stv: false,
    selected: null,
    selectedIndex: null,
    searchTitle: '',
    adminFormsPersistedState: null,
    errorState: false,
    pageNumber: 1,
    pageLength: 10,
    paginatedResults: [],
    results: null,
  });
  const {
    searchForUser,
    searchForAdminCustomer,
    searchForAdminErrorEmail,
    searchForAdminUser,
    searchForAdminDestTn,
    searchForAdminUserAdmin,
  } = useUserRequest();

  const submitSearch = async (type, ...params) => {
    setFormData((prevState) => ({
      ...prevState,
      showResults: false,
      loading: true,
    }));

    params.push(errorHandler);
    console.log('here: ', params);

    let results = [];
    console.log('type: ', type);
    console.log('params: ', params);

    if (type === 'SEARCH - USER') {
      results = await searchForUser({
        name: params[0],
        email: params[1],
        mob: params[2],
        errorHandler,
      });
    } else if (type === 'ADMIN SEARCH - CUSTOMER') {
      console.log('Got searchForAdminCustomer');
      results = await searchForAdminCustomer(
        params[0],
        params[1],
        params[2],
        params[3],
        params[4],
        errorHandler
      );
      setFormData((prevState) => ({
        ...prevState,
        hideSearchForm: true,
        searchTitle: type,
      }));
    } else if (type === 'ADMIN SEARCH - USER') {
      results = await searchForAdminUser(
        params[0],
        params[1],
        params[2],
        params[3],
        errorHandler
      );
      setFormData((prevState) => ({
        ...prevState,
        hideSearchForm: true,
        searchTitle: type,
      }));
    } else if (type === 'ADMIN SEARCH - ADMIN') {
      results = await searchForAdminUserAdmin(
        params[0],
        params[1],
        errorHandler
      );
      setFormData((prevState) => ({
        ...prevState,
        hideSearchForm: true,
        searchTitle: type,
      }));
    } else if (type === 'ADMIN SEARCH - EMAIL ERROR') {
      results = await searchForAdminErrorEmail(params[1], errorHandler);
      setFormData((prevState) => ({
        ...prevState,
        hideSearchForm: true,
        searchTitle: type,
      }));
    } else if (type === 'ADMIN SEARCH - MESSAGES VIA DESTINATION') {
      results = await searchForAdminDestTn(params[0], errorHandler);
      setFormData((prevState) => ({
        ...prevState,
        hideSearchForm: true,
        searchTitle: type,
      }));
    }

    console.log('Got search results:', results);

    if (!results.error) {
      setFormData((prevState) => ({
        ...prevState,
        showResults: true,
        results: results,
        loading: false,
        pageNumber: 1,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        loading: false,
        errorState: true,
      }));
    }
  };

  const selectUser = async (id, type, providerId, customerId) => {
    if (type === 'customer_user') {
      console.log('Clicked on a customer user');
      if (typeof id === 'undefined') {
        return setFormData((prevState) => ({
          ...prevState,
          stv: false,
          selected: null,
          type: type,
        }));
      }

      window.history.pushState(id, `users/${id}`, `/account/users`);

      await updateActingProviderDetails(providerId, errorHandler);
      await updateActingCustomerDetails(customerId, errorHandler);
      navigate('/account/users', {
        state: {
          stv: true,
          selected: id,
        },
      });
    } else if (type === 'user_report') {
      if (typeof id === 'undefined') {
        return setFormData((prevState) => ({
          ...prevState,
          stv: false,
          selected: null,
          type: type,
        }));
      }

      let selectedCustomerUser;
      let i;
      for (i = 0; i < formData.results.length; i++) {
        if (formData.results[i].customer_user_id === id) {
          selectedCustomerUser = formData.results[i];
          break;
        }
      }

      await updateActingProviderDetails(providerId, errorHandler);
      await updateActingCustomerDetails(customerId, errorHandler);
      navigate('/reports/user', {
        state: { userData: selectedCustomerUser },
      });
      console.log('Selected Customer User:', selectedCustomerUser);

      return setFormData((prevState) => ({
        ...prevState,
        stv: true,
        selected: selectedCustomerUser,
        type: type,
        selectedIndex: i,
      }));
    } else if (type === 'admin_contact') {
      console.log('Clicked on an admin');
      if (typeof id === 'undefined') {
        return setFormData((prevState) => ({
          ...prevState,
          stv: false,
          selected: null,
          type: type,
        }));
      }

      window.history.pushState(id, `Admin:${id}`, `/users/administrators`);
      await updateActingProviderDetails(providerId, errorHandler);
      await updateActingCustomerDetails(customerId, errorHandler);
      navigate('/users/administrators', {
        state: { selected: id, isHidingList: true },
      });
    } else if (type === 'customer') {
      console.log('Clicked on a customer');
      window.history.pushState(id, `Customer:${id}`, `/admin/customers/${id}`);
      await updateActingProviderDetails(providerId, errorHandler);
      await updateActingCustomerDetails(id, errorHandler);
      navigate('/admin/customers/' + id);
    } else if (type === 'provider') {
      console.log('Clicked on a provider');
      await updateActingProviderDetails(id);
      navigate('/admin/provider', {
        state: { showSingleProvider: true, selectedProvider: id },
      });
    } else if (type === 'email_recipient') {
      console.log('Clicked on a email recipient');
      if (typeof id === 'undefined') {
        return setFormData((prevState) => ({
          ...prevState,
          stv: false,
          selected: null,
          type: type,
        }));
      }

      let selectedEmailRecipient;
      let i;
      for (i = 0; i < formData.results.length; i++) {
        if (formData.results[i].email_id === id) {
          selectedEmailRecipient = formData.results[i];
          break;
        }
      }
      navigate('/reports/cost-center', {
        state: { userData: selectedEmailRecipient },
      });
      console.log('Selected Customer User:', selectedEmailRecipient);

      return setFormData((prevState) => ({
        ...prevState,
        stv: true,
        selected: selectedEmailRecipient,
        type: type,
      }));
    } else if (type === 'destination_number') {
      console.log('Clicked on a destination number');
    }
  };

  const changeEvent = (page) => {
    setFormData((prevState) => ({
      ...prevState,
      pageNumber: page,
    }));
  };

  const stvCallback = () => {
    setFormData((prevState) => ({
      ...prevState,
      stv: false,
    }));
  };

  const showResults = () => {
    if (typeof formData.results === 'undefined') {
      return (
        <Typography color="error">
          {FindCustomerFormattedMessages.errorReturningResults}
        </Typography>
      );
    }

    if (formData.results && formData.results.length === 0) {
      return (
        <Typography>{FindCustomerFormattedMessages.noResultsFound}</Typography>
      );
    }

    return (
      <Fragment>
        {!formData?.showResults ? (
          <Loader />
        ) : (
          <>
            <FindCustomerTable
              list={formData.results.slice(
                (formData.pageNumber - 1) * formData.pageLength,
                (formData.pageNumber - 1) * formData.pageLength +
                  formData.pageLength
              )}
              callBack={selectUser}
              type={formData.searchTitle}
            />
            <Paginator
              itemCount={formData?.results?.length}
              changeEvent={changeEvent}
              pageLength={formData.pageLength}
              pageNumber={formData.pageNumber}
            />
          </>
        )}
      </Fragment>
    );
  };

  const adminBack = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      showResults: false,
      hideSearchForm: false,
      stv: false,
      selected: null,
      selectedIndex: null,
      searchTitle: '',
      adminFormsPersistedState: {
        user_name: '',
        user_email: '',
        user_phone: '',
        user_id: '',
        customer_id: '',
        customer_name: '',
        customer_domain: '',
        customer_auth: '',
        customer_ip_address: '',
        admin_name: '',
        admin_email: '',
        error_name: '',
        error_email: '',
        destination_number: '',
        displayResults: false,
        searchType: null,
      },
      errorState: false,
      pageNumber: 1,
      pageLength: 10,
      paginatedResults: [],
      results: null,
    });
  };

  if (accessLevel !== '3' || accessType !== '3') {
    return null;
  }

  return (
    <Layout
      title={formData?.searchTitle || 'Find Customer'}
      routes={AdminRoutes}
      accessLevel={accessLevel}
      accessType={accessType}
      backButtonText={formData?.searchTitle && 'Back'}
      handleBackButton={adminBack}
    >
      {formData?.stv ? (
        <Users userData={formData?.selected} />
      ) : formData?.errorState ? (
        'Error'
      ) : formData?.loading ? (
        <Loader />
      ) : (
        <Fragment>
          {!formData?.hideSearchForm && (
            <AdminSearch
              searchHandler={submitSearch}
              formData={formData}
              setFormData={setFormData}
            />
          )}

          {formData?.showResults && showResults()}
        </Fragment>
      )}
    </Layout>
  );
};

export default AdminFindCustomer;
